"use client";
//#region packages/@mantine/core/src/core/utils/primitive/primitive.ts
function isPrimitive(value) {
	return typeof value === "string" || typeof value === "number" || typeof value === "boolean" || typeof value === "bigint";
}
//#endregion
export { isPrimitive };

//# sourceMappingURL=primitive.mjs.map